import React from 'react';
import CepField from '@catalogo/ui-americanas-mobile-cep-field';
import { FreightOptions } from '@catalogo/ui-americanas-mobile-freight/src/components/freight-options';
import { Wrapper } from './wrapper';
import { Container } from './container';

export const Content = ({ device, errorData, store, freight, isLoading }) => {
  if (device.toLowerCase() === 'mobile') {
    return (
      <Container device={device}>
        <Wrapper device={device}>
          <CepField label="encontre a loja mais proxima" error={errorData} />
          {!errorData && <FreightOptions store={store} freight={freight} isLoading={isLoading} />}
        </Wrapper>
      </Container>
    );
  }

  return (
    <Container device={device}>
      <CepField label="encontre a loja mais proxima" error={errorData} />
      {!errorData && (
        <Wrapper device={device}>
          <FreightOptions store={store} freight={freight} isLoading={isLoading} />
        </Wrapper>
      )}
    </Container>
  );
};
